/*
 * Copyright (c) 2017. by netzkolchose.de UG (haftungsbeschränkt) - stephan
 */

import lazy_image from 'lazy_image'
import $ from 'jquery'

$(()=>{
    $('[data-lazy-image]').each(function(){
        var i = new lazy_image(this, $(this).data('lazy-image'))
    });
});
